<template>
    <EditPaymentLiquidation1></EditPaymentLiquidation1>
</template>
<script>
    import EditPaymentLiquidation1 from '@/components/EditPaymentLiquidation1.vue'
    export default {
        name: 'employee-sign',
        components: {
            EditPaymentLiquidation1
        }
    }
</script>